import React, { useEffect, useState } from 'react';

import intro from "../../Images/vikalp..png";
import pattern from "../../Images/Shape-4.png";
import pattern2 from "../../Images/Shape-8.png";

export default function Landing(){
    const[offsetY, setOffsetY] = useState(0);
    const handleScroll = () => setOffsetY(window.pageYOffset);

    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () =>window.removeEventListener("scroll", handleScroll);
    },[])
    return(
        <div className="landing">
            <div className="intro-text" data-aos="fade-up">
                <h2 className="Title">Hi. I'm Vikalp.</h2>
                <h2 className="Title t2">A Developer.</h2>
                <p className="slogan">I’m full stack Developer and also a designer with a keen eye for creating engaging UI, bringing products to life.</p>
                <a href="/work"><button className="intro-btn">See My Portfolio!</button></a>
            </div>
            <div className="intro-img" data-aos="fade-up">
                <img src={intro} className="intro" />
            </div>
            <img 
                src={pattern} 
                className="paral" 
                style={{transform: `translateY(${offsetY * 0.6}px)`}} 
            />
            <img 
                src={pattern2} 
                className="paral2"
                style={{transform: `translateY(-${offsetY * 0.4}px)`}} 
             />
        </div>
    )
}